<template>
	<div class="content-wrapper">
		<template v-if="!!selectedStudent">
			<div class="row">
				<div class="col-sm-4 filter-col">
					<input type="text" name="quick-filter" placeholder="Quick Filter" class="form-control" v-model="searchQuery" />
				</div>
			</div>

			<br />
			<br />
			<!-- <template v-if="isCategorized"> -->
			<template v-if="filteredData.length > 0">
				<div class="row" v-for="(category, categoryIndex) in filteredData" :key="`category_${categoryIndex}`">
					<div class="col-sm-12">
						<panel-basic :title="category.REPORT_CATEGORY_DESC"
												 :id="`cabinet_${category.REPORT_CATEGORY_CODE}`"
												 :collapsable="true"
												 :defaultCollapsed="!category.EXPAND_GROUP"
												 :iconClass="getIcon(category.REPORT_CATEGORY_CODE)">
							<template slot="title">
								<font-awesome-icon :icon="getIcon(category.REPORT_CATEGORY_CODE)"></font-awesome-icon>
								{{ category.REPORT_CATEGORY_DESC }}
							</template>
							<template v-if="category.REPORT_CATEGORY_CODE === 'GRADERPT'" slot="icon">
								<span style="font-weight: bold; text-align: left; font-size: 30px; font-family: 'Font Awesome 5 Free'">
									A<font-awesome-icon icon="plus" style="vertical-align: top; font-size: 10px; margin-left-6px;"></font-awesome-icon>
								</span>
							</template>
							<template v-for="(folder, folderIndex) in category.FOLDERS">
								<section role="list"
												:key="`folder_${folderIndex}`">
									<div role="listitem" class="dir treeview active">
										<span @click="folder.EXPAND_FOLDER = !folder.EXPAND_FOLDER" style="cursor: pointer;">
											<font-awesome-icon icon="folder-open"
																				aria-hidden="true"
																				v-if="folder.EXPAND_FOLDER">
											</font-awesome-icon>
											<font-awesome-icon icon="folder"
																				aria-hidden="true"
																				v-else>
											</font-awesome-icon>
											{{ folder.REPORT_TYPE_DESC }}
										</span>
										<div class="container-fluid treeview-menu active" v-show="folder.EXPAND_FOLDER">
											<files-list :files="folder" :catCode="category.REPORT_CATEGORY_CODE"></files-list>
										</div>
									</div>
								</section>
							</template>
						</panel-basic>
					</div>
				</div>
			</template>
			<template v-else>
				<div :aria-label="$t('MAIN_CONTENT.FileCabinet.searchReturnedNoResults')" class="alert alert-info">
					{{ $t('MAIN_CONTENT.FileCabinet.searchReturnedNoResults') }}
				</div>
			</template>
		</template>
		<template v-else>
			{{ $t('MAIN_CONTENT.commonContent.noStudentHasBeenSelectedWithPeriod') }}
		</template>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import FilesList from './FilesList.vue';

	import PanelBasic from 'COMMONS/panels/PanelBasic.vue';

	import FileCabinet from '../../api/FileCabinet';

	/**
	*** @vue-data {Array} fileData - Array of data to display the groups, sections, folders, and files
	*** @vue-data {String} - String to determine which files to show if a string exists
	*** @vue-computed {Object} selectedStudent - selectedStudents information
	*** @vue-computed {String} role - which typeof user is signed in
	*** @vue-computed {Object} roleRules - Information on what permissions the user has based upon their role
	*** @vue-computed {Array} filteredData - Filtered fileData based upon the searchQuery string
	**/
	export default {
		data() {
			return {
				fileData: [],
				searchQuery: ''
			}
		},
		computed: {
			...mapGetters(['selectedStudent', 'role', 'roleRules']),
			/*
			*		Data displayed is based upon the filtedData computed property that is returned.
			*/
			filteredData() {
				let data = JSON.parse(JSON.stringify(this.fileData));
				let filterKey = this.searchQuery.toLowerCase();

				// Loop through all fileData if searchQuery.length is greater than 0
				if(!!this.searchQuery) {
					if(this.searchQuery.trim().length > 0) {
						for(let c = 0; c < data.length; c++) {
							let category = data[c];

							// Loop through the category FOLDERS array
							for(let f = 0; f < category.FOLDERS.length; f++) {
								let folder = category.FOLDERS[f];

								// Loop through the SECTIONS array
								for(let s = 0; s < folder.SECTIONS.length; s++) {
									let section = folder.SECTIONS[s];
									let filesToInclude = [];

									// Loop through the FILES array
									for(let i = 0; i < section.FILES.length; i++) {
										let file = section.FILES[i];
										let fileTitle = file.REPORT_TITLE.toLowerCase();

										if(fileTitle.includes(filterKey)) {
											filesToInclude.push(file);
										}
									}

									section.FILES = filesToInclude;

									if(section.FILES.length === 0) {
										folder.SECTIONS.splice(s, 1);
										s--;
									}
								}

								if(folder.SECTIONS.length === 0) {
									category.FOLDERS.splice(f, 1);
									f--;
								}
							}

							if(category.FOLDERS.length === 0) {
								data.splice(c, 1);
								c--;
							} else {
								category.EXPAND_GROUP = true;
							}
						}
					}
				}

				return !!this.searchQuery ? data : this.fileData;
			}
		},
		components: {
			FilesList,
			PanelBasic
		},
		methods: {
			/**
				* Fetches the reports
			*/
			fetchReports() {
				const self = this;

				const fileCabinet = new FileCabinet({
					route: '/reports',
					query: {
						student_rid: this.selectedStudent.STUDENT_RID
					}
				});

				const promise = fileCabinet.get();

				promise.then(response => {
					let data = response.data.data;
					let returnData = self.createGroups(data);

					self.$set(self, 'fileData', self.orderCategoryList(returnData));
				})
				.catch(error => {
					console.log(error);
				});
			},
			// Builds the groups and calls the createFolderList to build the folder array
			createGroups(data) {
				let groups = [];
				let groupNames = [];

				for(let g in data) {
					let fileInfo = data[g];
					let nameExists = false;

					// Check if groupNames exists in groupNames
					for(let i in groupNames) {
						// If groupName does exists, set nameExists to tru
						if(groupNames[i] === fileInfo.REPORT_CATEGORY_CODE) {
							nameExists = true;
						}
					}

					if(!nameExists) {
						// Add group name code to list so we don't create multiple groups of the same name
						groupNames.push(fileInfo.REPORT_CATEGORY_CODE);
						// Add group object to the groups list
						groups.push({
							REPORT_CATEGORY_DESC: fileInfo.REPORT_CATEGORY_DESC,
							REPORT_CATGORY_CODE_IMAGE_NAME: fileInfo.REPORT_CATGORY_CODE_IMAGE_NAME,
							REPORT_CATEGORY_CODE: fileInfo.REPORT_CATEGORY_CODE,
							REPORT_CATEGORY_ORDER_NO: fileInfo.REPORT_CATEGORY_ORDER_NO,
							EXPAND_GROUP: true,
							FOLDERS: this.createFolderList(fileInfo.REPORT_CATEGORY_CODE, data)
						});
					}
				}

				return groups;
			},
			// Builds the folder array based upon the groupID and calls the getFolderSections to build the SECTIONS array
			createFolderList(groupID, data) {
				let folders = [];
				let folderNames = [];

				for(let d in data) {
					let info = data[d];
					let nameExists = false;

					// Check if group code matches files group code
					if(groupID === info.REPORT_CATEGORY_CODE) {
						// Check if folder names exists
						for(let i in folderNames) {
							let folderName = folderNames[i];

							// Check if folder exists in folderNames
							if(folderName === info.REPORT_TYPE_CODE) {
								nameExists = true;
							}
						}

						if(!nameExists) {
							// Update folderNames list with REPORT_TYPE_CODE
							folderNames.push(info.REPORT_TYPE_CODE);
							// Add folder object to FOLDERS in group
							folders.push({
								REPORT_TITLE: info.REPORT_TITLE,
								REPORT_DESCRIPTION: info.REPORT_DESCRIPTION,
								REPORT_TYPE_CODE: info.REPORT_TYPE_CODE,
								REPORT_TYPE_DESC: info.REPORT_TYPE_DESC,
								REPORT_TYPE_ORDER_NO: info.REPORT_TYPE_ORDER_NO,
								EXPAND_FOLDER: true,
								SECTIONS: this.getFolderSections(groupID, info.REPORT_TYPE_CODE, data)
							});
						}
					}
				}

				return folders;
			},
			// Builds the SECTIONS array based upon the groupID and folderID and then adds the files data to the files array by calling the addFilesToSections
			getFolderSections(groupID, folderID, data) {
				let sections = [];
				let sectionDates = [];

				// Loop through list of files
				for(let d in data) {
					let info = data[d];

					// Check if files group id matches groupID
					if(info.REPORT_CATEGORY_CODE === groupID) {
						// Check if folderID matches files folder id, if is a match, file should exists somewhere within sections array
						if(info.REPORT_TYPE_CODE === folderID) {
							let nameExists = false;

							// Loop through sections in folders to verify if they exists
							for(let s in sectionDates) {
								let section = sectionDates[s];

								// If info.SCHOOL_YEAR_DESC matches the section name
								if(!!info.SCHOOL_YEAR_DESC) {
									if(info.SCHOOL_YEAR_DESC === section) {
										nameExists === true;
									}
								} else {
									if(section === 'BLANK') {
										nameExists = true;
									}
								}
							}

							// If the section does nto exists, update the sectionDates list and the sections array
							if(!nameExists) {
								// If section is blank
								if(!info.SCHOOL_YEAR_DESC) {
									sectionDates.push('BLANK');
									sections.push({
										SHOW_SECTIONS: true,
										SECTION_CODE: 'BLANK',
										FILES: this.addFilesToSections(groupID, folderID, 'BLANK', data)
									});
								} else {
									sectionDates.push(info.SCHOOL_YEAR_DESC);
									sections.push({
										SHOW_SECTIONS: true,
										SECTION_CODE: info.SCHOOL_YEAR_DESC,
										FILES: this.addFilesToSections(groupID, folderID, info.SCHOOL_YEAR_DESC, data)
									});
								}
							}
						}
					}
				}

				// Removes duplicate sections
				if(sections.length > 1) {
					let uniqueSections = [];
					let uniqueSection = {};

					for(let i in sections) {
						let title = sections[i]['SECTION_CODE'];

						uniqueSection[title] = sections[i];
					}

					for(let i in uniqueSection) {
						uniqueSections.push(uniqueSection[i]);
					}

					sections = uniqueSections;
				}

				return sections;
			},
			// Returns files array that for files in data object that matches groupID, folderID, and sectionID
			addFilesToSections(groupID, folderID, sectionID, data) {
				let files = [];

				for(let i in data) {
					let file = data[i];

					if(groupID === file.REPORT_CATEGORY_CODE) {
						if(folderID === file.REPORT_TYPE_CODE) {
							if(!file.SCHOOL_YEAR_DESC && sectionID === 'BLANK') {
								files.push(file);
							} else {
								if(sectionID === file.SCHOOL_YEAR_DESC) {
									files.push(file);
								}
							}
						}
					}
				}

				return files;
			},
			orderCategoryList(data) {
				let returnData = data.sort((a, b) => {
					if(a.REPORT_CATEGORY_ORDER_NO < b.REPORT_CATEGORY_ORDER_NO) {
						return -1;
					}

					if(a.REPORT_CATEGORY_ORDER_NO > b.REPORT_CATEGORY_ORDER_NO) {
						return 1;
					}

					return 0;
				});

				return returnData;
			},
			getIcon(categoryType) {
				let icon = '';

				switch(categoryType) {
					case 'SYSOFFICE':
						icon = 'briefcase';
						break;
					case 'SYSMEDICAL':
						icon = 'file-medical';
						break;
					case 'NOTICE':
						icon = 'bullhorn';
						break;
					case 'SYSSPECSRV':
						icon = 'chalkboard';
						break;
					case 'GRADERPT':
						icon = 'font';
						break;
					case 'Onlinereg':
					case 'Career':
					case 'CTC':
					case 'NCAA':
						icon = 'file';
						break;
					case 'PDF':
						icon = 'file-pdf';
						break;
					default:
						icon = 'file';
						break;
				}

				return icon;
			}
		},
		created() {
			this.$store.commit('setTitleIcon', 'archive');
			this.$store.commit('setTitle', 'MAIN_CONTENT.FileCabinet.navPanelFileCabinet');
			this.$store.commit('setUseHeader', true);
			this.fetchReports();
		}
	}
</script>
